import React, { useEffect, useState, useCallback } from 'react';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Box, Link, TextField, Autocomplete } from '@mui/material';
import axios from 'axios';

export default function DocumentDataGrid() {
  const [rows, setRows] = useState([]);
const [totalCount, setTotalCount] = useState(0);
const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

const [searchText, setSearchText] = useState('');
const [selectedCategories, setSelectedCategories] = useState([]);
const [categoryOptions, setCategoryOptions] = useState([]);
const [columnVisibilityModel, setColumnVisibilityModel] = useState({
  category: true, // unhide this column
});



useEffect(() => {
  const fetchDocs = async () => {
    const page = paginationModel.page + 1; // backend is 1-based
    const limit = paginationModel.pageSize;
    const search = encodeURIComponent(searchText.trim());
    const categories = selectedCategories.map(encodeURIComponent).join(',');

    const url = `https://api.alachuacounty.us/cabotkoppers-documents-api/api/documents?page=${page}&limit=${limit}&search=${search}&categories=${categories}`;
    const res = await fetch(url,{cache: 'no-store'});
    const data = await res.json();

    setRows(data.documents);
    setTotalCount(data.total);
    setCategoryOptions(data.categoryOptions || []);
  };

  fetchDocs();
}, [paginationModel, searchText, selectedCategories]);


 
const columns = [
  {
    field: 'fileName',
    headerName: 'Name',
    flex:4,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
            <Link
              href={`https://api.alachuacounty.us/cabotkoppers-documents-api/api/download/${params.row.id}`}
              rel="noopener noreferrer"
            >
              {params.value}
            </Link>
          )
  },
  {
    field: 'category',
    headerName: 'Category',
flex:1,
    //width: 150,
    //hide: true,
  },
  {
    field: 'documentDate',
    headerName: 'Date',
    flex:1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
    const dateValue = params.value ? new Date(params.value) : null;
    if (!dateValue || isNaN(dateValue)) return '—';
    return new Intl.DateTimeFormat('en-US').format(dateValue);
  }
  },
  {
    field: 'fileSizeKB',
    headerName: 'File Size',
    flex:1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const bytes = Number(params.value);
      if (!bytes) return '';
      const kb = bytes / 1024;
      return kb >= 1024
        ? `${(kb / 1024).toFixed(2)} MB`
        : `${kb.toFixed(1)} KB`;
    }
  }
];


  return (
    <> 
    
{/* <p>Rows: {rows.length}</p>
<p>Total Rows: {totalCount}</p>
<p>Page: {paginationModel.page + 1}</p>  */}

<Box sx={{ display: 'flex', gap: 2, mb: 0, padding:2 }}>
  <Autocomplete
    multiple
    options={categoryOptions}
    value={selectedCategories}
    onChange={(e, val) => setSelectedCategories(val)}
    renderInput={(params) => <TextField {...params} label="Filter by Category" />}
    sx={{ width: 300 }}
  />
  <TextField
    label="Search"
    variant="outlined"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    sx={{ width: 300 }}
  />
</Box>
    <Box sx={{ maxHeight: 795, width: '100%', padding: 2, display: 'flex',
        flexDirection: 'column', }}>
      <DataGridPremium
  rows={rows}
  rowCount={totalCount}
  columns={columns}
  pagination
  pageSizeOptions={[10, 20, 50]}
  paginationModel={paginationModel}
  onPaginationModelChange={(newModel)=>setPaginationModel(newModel)}
  paginationMode="server"
  filterMode="server"

  disableRowSelectionOnClick
  columnVisibilityModel={columnVisibilityModel}
  onColumnVisibilityModelChange={setColumnVisibilityModel}

  autoHeight = {true}

  sx={{
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#002D59!important',
      color: '#fff',
      borderBottom: '1px solid #ccc',
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#002D59!important',
      color: '#fff',
      minHeight: '56px',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      color: '#fff',
      fontWeight: 'bold',
    },
    '& .MuiDataGrid-iconButtonContainer': {
      color: '#fff',
    },
    '& .MuiDataGrid-sortIcon': {
      color: '#fff',
    },
    '& .MuiDataGrid-main': {
      backgroundColor: '#f9f9f9', 
    },
   '& .MuiDataGrid-main': {
            height: 'calc(100% - 52px) !important', // subtract footer height (~52px)
          },
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto !important',
            height: '100% !important',
          },
          '& .MuiDataGrid-footerContainer': {
            position: 'sticky',
            bottom: 0,
            backgroundColor: '#fff',
            borderTop: '1px solid rgba(224, 224, 224, 1)',
            zIndex: 1,
          },
  }}
/>
    </Box>
    </>
  );
}
